// extracted by mini-css-extract-plugin
export default {"filterWrap":"allocation-list_filterWrap__ipKXC","tabWrapAllocation":"allocation-list_tabWrapAllocation__KfT3X"};